var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpecificBequests = function SvgSpecificBequests(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 424,
    height: 94,
    fill: "none",
    viewBox: "0 0 424 94"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "M212.5 76.5h-1v-16h1zM211.5 31.5v-10h1v10A3.5 3.5 0 0 0 216 35h18v1h-18a4.5 4.5 0 0 1-4.5-4.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "M211.5 49.5v-34h1v34A3.5 3.5 0 0 0 216 53h18v1h-18a4.5 4.5 0 0 1-4.5-4.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "M186.5 68.68a3.5 3.5 0 0 1 3.5-3.5h18a4.5 4.5 0 0 0 4.5-4.5V44.5h-1v16.18a3.5 3.5 0 0 1-3.5 3.5h-18a4.5 4.5 0 0 0-4.5 4.5v5.82h1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "M237.5 68.68a3.5 3.5 0 0 0-3.5-3.5h-18a4.5 4.5 0 0 1-4.5-4.5V44.5h1v16.18a3.5 3.5 0 0 0 3.5 3.5h18a4.5 4.5 0 0 1 4.5 4.5v5.82h-1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 212.334,
    cy: 17.5,
    r: 9,
    fill: "#4B5563"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 79.5,
    r: 6,
    fill: "#4B5563"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 79.5,
    r: 6,
    fill: "#4B5563"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 79.5,
    r: 6,
    fill: "#4B5563"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 35.5,
    r: 6,
    fill: "#4B5563"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 53.5,
    r: 6,
    fill: "#4B5563"
  })));
};
export default SvgSpecificBequests;